<div class="loading-container">
    <div class="loading-title">{{ data.title || 'loading.dialog.title' | translate }}</div>
    <div class="loading-percentage">{{ data.progress }}%</div>
    <div class="loading-bar-container">
        <div class="loading-bar-fill" [style.width.%]="data.progress"></div>
    </div>
    <div class="loading-message">{{ data.text || 'loading.dialog.main-text' | translate }}</div>
</div>